export enum WorkItemSource {
  Unknown = 0,
  ConsatSystemEvent = 1,
  ConsatVehicleEvent = 2,
  RuterSalesDiagnosticEvent = 3,
  ScheduleData = 4,
}

export enum PtaReportSource {
  Api = 1,
  Manual = 2,
}

// Mirrors PtaUpdateOutcome.cs in connect-bus-api
// (src/ConnectBus.Application/Features/WorkItems/Common/Responses).
export enum PtaUpdateOutcome {
  NotApplicable = 0,
  Sent = 1,
  NotChanged = 2,
  Expired = 3,
  Failed = 4,
}

// Mirrors connect-bus-api
// src/ConnectBus.Application/Features/WorkItems/Common/Responses/PtaDeleteOutcome.cs:7-26.
export enum PtaDeleteOutcome {
  NotApplicable = 0,
  Annulled = 1,
  DeletedWithoutAnnul = 2,
}

// Mirrors PtaDeviationReportAction.cs in connect-bus-api
// (src/ConnectBus.Domain/Journal/Enums).
export enum PtaDeviationReportAction {
  Reported = 1,
  Updated = 2,
  Annulled = 3,
}

export enum UrgencyLevel {
  Low = 10,
  Medium = 20,
  High = 30,
}

export enum WorkItemType {
  Undefined = 0,
  MinorDelay = 1,
  Delay = 2,
  EarlyJourneyDeparture = 3,
  EarlyStopDeparture = 4,
  ProjectedDelay = 5,
  WrongVehicle = 6,
  VehicleFault = 7,
  RouteChange = 8,
  AdditionalJourney = 9,
  Cancellation = 10,
  MissedPickup = 11,
  DigitalServices = 12,
  AvoidedCancellation = 13,
  Towing = 14,
  BusIsLate = 15,
}

export enum WorkItemStatus {
  Draft = 0,
  Queued = 1,
  Done = 2,
  Projected = 3,
  Archive = 99,
}

export enum WorkItemStatusString {
  Draft = 'draft',
  Queued = 'queued',
  Done = 'done',
  Projected = 'projected',
  Archive = 'archive',
  Create = 'create',
}

export enum WorkItemCreationType {
  Undefined = 0,
  Automatic = 1,
  Manual = 2,
}

export enum WorkItemReason {
  // Technical (1x)
  TechnicalBrakes = 11,
  TechnicalDoor = 12,
  TechnicalDrivetrain = 13,
  TechnicalOther = 14,
  TechnicalLowSoC = 15,

  // Digital Services (2x)
  DigitalServicesTaaS = 21,
  DigitalServicesTicketMachine = 22,
  DigitalServicesGPS = 23,
  DigitalServicesAPC = 24,
  DigitalServicesExternalSign = 25,
  DigitalServicesDPI = 26,
  DigitalServicesSupplier = 27,

  // Infrastructure (3x)
  InfrastructureDebris = 31,
  InfrastructureObstruction = 32,

  // Traffical (4x)
  TrafficalRushHour = 41,
  TrafficalCongestion = 42,
  TrafficalRoadAccident = 43,
  TrafficalParkedVehicle = 44,
  TrafficalSlipperyRoads = 45,
  TrafficalDemonstration = 46,
  TrafficalEarlierDelay = 47,
  TrafficalOther = 48,
  TrafficalCorrespondence = 49,

  // Personnel (5x)
  PersonnelPersonalNeeds = 51,
  PersonnelHumanError = 52,

  // Ticketing (6x)
  TicketingCustomerCare = 61,
  TicketingInspection = 62,

  // Accident (7x)
  AccidentFaultFined = 71,
  AccidentFaultNoFines = 72,

  // Other Categories (8x)
  EarlierDelay = 81,
  Event = 82,
  FullBus = 83,
}

export enum JourneyType {
  DeadRun = 0,
  ServiceJourney = 1,
}

export enum WorkItemChangeSetType {
  User = 1,
  Api = 2,
  Rtp = 3,
}

export enum AlarmSeverity {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum TowingCriticality {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum CancellationType {
  Partial = 1,
  Full = 2,
}

export enum CancellationTypeString {
  Partial = 'partial',
  Full = 'full',
}

export enum AlarmConfigurationType {
  Delay = 1,
  ProjectedDelay = 2,
  BusIsLate = 3,
}

export enum AlarmConfigurationTypeString {
  Delay = 'delay',
  ProjectedDelay = 'projected_delay',
  BusIsLate = 'bus_is_late',
}

export enum WorkItemErrorCode {
  Unknown = 0,
  WorkItemCreateError = 1,
  WorkItemNotValid = 2,
  PtaReportValidationError = 3,
  PtaReportFailed = 4,
}

export enum WorkItemErrorCodeString {
  Unknown = 'unknown',
  WorkItemCreateError = 'work_item_create_error',
  WorkItemNotValid = 'work_item_not_valid',
  PtaReportValidationError = 'pta_report_validation_error',
  PtaReportFailed = 'pta_report_failed',
}
